import {Box, VStack} from '@chakra-ui/react';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {jcProductPurchasesListRequest} from '../../reducers/gooodReducer';
import PageTitle from '../WooorldInApp/PageTitle';
import TableEditor from './TableEditor';

const dateToLabel = value => value ? new Date(value).toLocaleString() : '';

const idToLabel = value => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return value.alias || value.name || value._id || value.id || JSON.stringify(value);
};

const productToName = product => {
  if (!product) return '';
  if (typeof product === 'string') return product;
  return product.name || product.internalName || product._id || product.id || JSON.stringify(product);
};

const productToInternalName = product => {
  if (!product || typeof product === 'string') return '';
  return product.internalName || '';
};

const transactionToAmount = transaction => {
  if (!transaction || typeof transaction === 'string') return '';
  return transaction.amount;
};

const JcProductPurchasesTable = () => {
  const {
    error,
    isLoading,
    response,
  } = useSelector(s => s.goood.jcProductPurchasesAdmin);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!response && !isLoading && !error) {
      dispatch(jcProductPurchasesListRequest({}));
    }
  }, [response, isLoading, error, dispatch]);

  const recentPurchases = (response?.recentPurchases || []).map(item => ({
    ...item,
    productInternalName: productToInternalName(item.product),
    productName: productToName(item.product),
    transactionAmount: transactionToAmount(item.transaction),
    userAlias: item.purchaser?.alias || idToLabel(item.purchaser),
  }));
  const topSellingProducts = response?.topSellingProducts || [];

  return (
    <Box width="full">
      <PageTitle title="jcProductPurchases - Goood"/>
      <VStack align="stretch" p={4} spacing={4} width="full">
        <TableEditor
          error={error}
          fields={[
            {
              isReadOnly: true,
              key: '_id',
              valToLabel: idToLabel,
            },
            {
              isReadOnly: true,
              key: 'productName',
            },
            {
              isReadOnly: true,
              key: 'internalName',
            },
            {
              isReadOnly: true,
              key: 'price',
            },
            {
              isReadOnly: true,
              key: 'purchaseCount',
            },
            {
              isReadOnly: true,
              key: 'mostRecentPurchaseOn',
              valToLabel: dateToLabel,
            },
          ]}
          isLoading={isLoading}
          items={topSellingProducts}
          title="Top selling products"
        />

        <TableEditor
          error={error}
          fields={[
            {
              isReadOnly: true,
              key: '_id',
              valToLabel: idToLabel,
            },
            {
              isReadOnly: true,
              key: 'createdOn',
              valToLabel: dateToLabel,
            },
            {
              isReadOnly: true,
              key: 'productName',
            },
            {
              isReadOnly: true,
              key: 'productInternalName',
            },
            {
              isReadOnly: true,
              key: 'userAlias',
            },
            {
              isReadOnly: true,
              key: 'transactionAmount',
            },
          ]}
          isLoading={isLoading}
          items={recentPurchases}
          title="Recent purchases"
        />

      </VStack>
    </Box>
  );
};

export default JcProductPurchasesTable;
